import { render, staticRenderFns } from "./PeerGroupRoleSelectorPills.vue?vue&type=template&id=14f524e3&scoped=true&"
import script from "./PeerGroupRoleSelectorPills.vue?vue&type=script&lang=ts&"
export * from "./PeerGroupRoleSelectorPills.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14f524e3",
  null
  
)

export default component.exports